export enum UserRole {
    Administrator,
    User,
    Deliverer,
    Picker,
    ProviderAdmin,
    TasksExplorer,
    OrdersExplorer,
    Supporter,
    InstantDeliverer,
    ProviderShopUser,
    AreaManager,
    Translator,
    ITSupport,
    LogBrowser,
    MobileTester,
    SupplierSupervisor,
    Refunder,
    ProductMapEditor,
}
